import(/* webpackMode: "eager" */ "/vercel/path0/src/app/news/[slug]/page.tsx");
